import React, { useEffect, useState } from 'react'
import * as locCon from '../LocalConstants';
import CustomText from '../elements/CustomText';
import { RefLanguageAndLocale } from '../hooks/LanguageHooks';
import * as libCon from '../community-hats-js-library/Constants';
import CollectionStatus from '../elements/CollectionStatus';
import { SimpleCopyField } from '../elements/SimpleStoreCopyField';
import { getPendingActionItems, RefActionItemsStatus, RefPendingActionItems, refreshActionItems, updateActionItem } from '../hooks/BundleDeviceHooks';
import { showErrorDialogByCode } from '../utils/dialogFunctions';
import { getActionItemColumnsByLocale, showNotification } from '../utils/generalFunctions';
import CustomSpin from '../elements/CustomSpin';
import { RefATObjectId, RefStoredValue, StateStoredValue } from '../hooks/StoreHooks';
import { isNullOrUndefined } from '../community-hats-js-library/utils/generalFunctions';
import { formatDistanceShort, formatToStudyLocationReadable } from '../community-hats-js-library/utils/dateFunctions';
import { CustomPrimaryButtonWithDisability } from '../elements/CustomButton';
import { Tag } from 'antd';
import { SimpleStoreCopyTextAreaFromId } from '../elements/SimpleStoreCopyTextArea';
import { markIssueAsReadyForRevision as markActionItemAsReadyForRevision } from '../community-hats-js-library/back-end/router';
import { RefContextLanguage } from '../providers/LanguageProvider';
import { compareIssues as compareActionItems } from '../community-hats-js-library/utils/devicesStatusFunctions';


export const CustomTag = ({ tagText, i }) => {
    return (<Tag color={libCon.TAG_COLORS[i % libCon.TAG_COLORS.length]}
        style={{
            marginLeft: "3px",
            marginRight: "3px"
        }}>
        {tagText}
    </Tag>)
}


const SingleActionItemStatusViewer = ({ actionItemId, actionItem, position, notesId }) => {

    const [i18n, locale] = RefLanguageAndLocale()

    const [descriptionKey, setDescriptionKey] = useState(libCon.ATF_DESCRIPTION)
    const [actionKey, setActionKey] = useState(libCon.ATF_ACTION)

    useEffect(() => {

        const [newDescriptionKey, newActionKey] = getActionItemColumnsByLocale(locale)
        setDescriptionKey(newDescriptionKey)
        setActionKey(newActionKey)

    }, [locale])


    const [notes, setNotes] = StateStoredValue(notesId)

    const [isSending, setIsSending] = useState(false)

    const localSenddForRevision = async () => {
        setIsSending(true)



        const [response, newActionItem] = await markActionItemAsReadyForRevision(actionItem, notes, libCon.CH_MANAGERE_APP)

        if (response === libCon.OK) {

            setNotes(null)
            updateActionItem(actionItemId, newActionItem[actionItemId])
            showNotification(i18n.t("actionItemSentForRevisionSuccessfully"))
        }
        else
            showErrorDialogByCode(response)

        setIsSending(false)

    }


    return (
        <div className='verticalSection' style={{
            backgroundColor: "var(--background-color-2)",
            marginTop: "1vh",
            marginBottom: "1vh",
            width: "95%",
            padding: "1vh",
            borderColor: "var(--warning-color-1)",
            borderStyle: "solid",
            borderWidth: actionItem[libCon.ATF_SEVERITY] === libCon.ATF_HIGH ? "3px" : "0px",
            borderRadius: "15px"
        }}>
            <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t("actionItem") + " " + position}</CustomText>

            <CustomText type={locCon.ELEMENT_TITLE_TEXT} style={{ marginTop: "2vh" }}>{i18n.t("priority")}</CustomText>
            <CustomText type={locCon.INFO_TEXT}>{i18n.t(actionItem[libCon.ATF_SEVERITY])}</CustomText>




            <CustomText type={locCon.ELEMENT_TITLE_TEXT} style={{ marginTop: "1vh" }}>{i18n.t("tags")}</CustomText>
            <div className='horizontalSection'>
                {actionItem[libCon.ATF_TAGS].map((t, i) => <CustomTag key={i} tagText={t} i={i} />)}
            </div>

            <CustomText type={locCon.ELEMENT_TITLE_TEXT} style={{ marginTop: "2vh" }}>{i18n.t("description")}</CustomText>
            <CustomText type={locCon.INFO_TEXT}>{actionItem[descriptionKey]}</CustomText>

            <CustomText type={locCon.ELEMENT_TITLE_TEXT} style={{ marginTop: "2vh" }}>{i18n.t("action")}</CustomText>
            <CustomText type={locCon.INFO_TEXT} style={{ marginBottom: "2vh" }}>{actionItem[actionKey]}</CustomText>


            <SimpleStoreCopyTextAreaFromId title={i18n.t("notes")} valueID={notesId} />


            {isSending
                ? <CustomSpin type={locCon.BUTTON_SPINNER} />
                : <CustomPrimaryButtonWithDisability onClick={() => localSenddForRevision()} isDisabled={isNullOrUndefined(notes)} title={i18n.t("incomplete")} description={i18n.t("pleaseIncludeNotes")}>{i18n.t("sendForRevision")}</CustomPrimaryButtonWithDisability>
            }



        </div>
    )

}



function ActionItemsStatusViewer({ includeTitle = true }) {


    const i18n = RefContextLanguage()

    const participantId = RefATObjectId(locCon.AT_OBJECT_PARTICIPANT)


    const pendingActionItems = RefPendingActionItems()
    const lastActionItemCheck = RefStoredValue(locCon.LAST_ACTION_ITEM_CHECK)

    const [actionItemNumbers, setActionItemNumbers] = useState({})

    const [status, message] = RefActionItemsStatus()


    const [isSynching, setisSynching] = useState(false)


    const refreshRecords = async () => {
        setisSynching(true)
        let response = await refreshActionItems()

        if (response !== libCon.OK)
            showErrorDialogByCode(response)
        else
            showNotification(i18n.t("refreshComplete"))

        setisSynching(false)
    }


    useEffect(() => {
        let currentPendingActionItems = getPendingActionItems()
        setActionItemNumbers(Object.fromEntries(Object.keys(currentPendingActionItems).sort((k1, k2) => compareActionItems(currentPendingActionItems[k1], currentPendingActionItems[k2])).map((k, i) => [k, i + 1])))
    }, [lastActionItemCheck])




    return (
        <div className='verticalSection'>
            {includeTitle ? <CustomText type={locCon.SECTION_TITLE_TEXT}>{i18n.t("actionItems")}</CustomText> : <div></div>}

            <CollectionStatus status={status} message={message} />


            <SimpleCopyField title={i18n.t("lastRefreshed")} value={isNullOrUndefined(lastActionItemCheck) ? i18n.t("never") : <>{`${formatToStudyLocationReadable(lastActionItemCheck, true, false)}`}<br />{`(${formatDistanceShort(lastActionItemCheck)})`}</>} enableCopy={false} />

            {
                isSynching
                    ? <CustomSpin type={locCon.BUTTON_SPINNER} />
                    : <CustomPrimaryButtonWithDisability isDisabled={isNullOrUndefined(participantId)} title={i18n.t("incompleteDeployment")} description={i18n.t("addParticipant")} onClick={() => refreshRecords()}>{i18n.t("refresh")}</CustomPrimaryButtonWithDisability>
            }

            {
                Object.keys(pendingActionItems).length > 0
                    ? <div className='verticalSection'>
                        <CustomText type={locCon.ELEMENT_TITLE_TEXT} style={{ marginTop: "1vh" }}>{i18n.t("pendingActionItems")}</CustomText>
                        {
                            Object.keys(pendingActionItems).sort((k1, k2) => compareActionItems(pendingActionItems[k1], pendingActionItems[k2])).map((k, i) => <SingleActionItemStatusViewer key={k} actionItemId={k} notesId={k + libCon.ATF_NOTES} actionItem={pendingActionItems[k]} position={k in actionItemNumbers ? actionItemNumbers[k] : ""} />)
                        }
                    </div>
                    : <div></div>

            }


        </div>
    )
}

export default ActionItemsStatusViewer